import { ButtonAnchor, SelectField, TextField } from '../../components/common'
import { FormProps, SectionHeading, UpdateButton, useSettingsForm } from './forms'
import styles from './SettingsPage.module.scss'

type CalendarValues = { session_duration: number; session_max_blocks: number; boxes_names: string }

export function CalendarSettingsForm({ settings, onDirty, onClean, onSubmit }: FormProps<CalendarValues>) {
  const { health_center, session_durations, session_max_blocks, paths } = settings
  const { values, set, submitting, handleSubmit, formRef } = useSettingsForm(
    {
      session_duration: health_center.session_duration,
      session_max_blocks: health_center.session_max_blocks,
      boxes_names: health_center.boxes_names,
    },
    { onDirty, onClean, onSubmit },
  )

  return (
    <form ref={formRef} onSubmit={handleSubmit}>
      <h3 className="text-center blue-subtitle">Configuración de agenda</h3>
      <SectionHeading>Duración de cada sesión en el calendario</SectionHeading>
      <SelectField
        className="col-xs-12 col-sm-6"
        label="Mínima duración de un bloque"
        value={values.session_duration}
        onChange={(value) => set('session_duration')(Number(value))}
        options={session_durations.map((minutes) => ({ value: minutes, label: `${minutes} minutos` }))}
      />
      <SelectField
        className="col-xs-12 col-sm-6"
        label="Máxima duración de un bloque"
        value={values.session_max_blocks}
        onChange={(value) => set('session_max_blocks')(Number(value))}
        options={session_max_blocks.map((blocks) => ({ value: blocks, label: `${blocks * values.session_duration} minutos` }))}
      />

      <h4 className={`text-center blue-subtitle ${styles.boxesHeading}`}>Número de agendas / salas de atención</h4>
      <label className={styles.fullWidthLabel}>
        Escribe los nombres de las salas de atención de tu centro, separándolas con una ","
      </label>
      <label className={styles.fullWidthLabel}>Ejemplo: "Box 1, Box 2, Sala de cirugía, Box 3"</label>
      <label className={styles.fullWidthLabel}>
        {`Actualmente tienes un límite de ${health_center.max_boxes} agendas / salas de atención`}
      </label>
      <div className={`col-xs-12 ${styles.centered}`}>
        <TextField label="" value={values.boxes_names} onChange={set('boxes_names')} />
      </div>

      <SectionHeading>Disponibilidad de los profesionales para atención</SectionHeading>
      <div className={`col-xs-12 ${styles.centered}`}>
        <ButtonAnchor href={paths.professionals} variant="secondary">
          Configurar horarios
        </ButtonAnchor>
      </div>
      <div className="col-xs-12">
        <UpdateButton submitting={submitting} />
      </div>
    </form>
  )
}
